import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 32,
	height: 32,
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M9.333 3.111c.43 0 .778.348.778.778v4.666h4.667c.394 0 .719.293.77.673l.008.105c0 .43-.349.778-.778.778H10.11l.001 4.667c0 .394-.292.719-.672.77l-.106.008a.778.778 0 0 1-.777-.778V10.11l-4.667.001a.778.778 0 0 1-.77-.672l-.008-.106c0-.43.348-.777.778-.777h4.666V3.888c0-.394.293-.72.673-.77Z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#1A1A1A",
			fillRule: "nonzero",
			d: "M20.104 28.77c0-1.106.9-2.007 2.007-2.007 1.107 0 2.007.9 2.007 2.008a2.01 2.01 0 0 1-2.007 2.007 2.01 2.01 0 0 1-2.007-2.007Zm2.867 0a.861.861 0 0 0-1.72 0 .861.861 0 0 0 1.72 0ZM14.37 26.763c1.106 0 2.006.9 2.006 2.008a2.01 2.01 0 0 1-2.007 2.007 2.01 2.01 0 0 1-2.007-2.007c0-1.107.9-2.008 2.007-2.008Zm0 2.868a.861.861 0 0 0 0-1.72.861.861 0 0 0 0 1.72ZM24.669 25.49a.573.573 0 0 1-.694.393.556.556 0 0 1-.143.02H12.935a.574.574 0 0 1-.565-.479l-1.147-6.882a.573.573 0 0 1 .484-.662l12.043-1.72a.573.573 0 1 1 .163 1.135L12.45 18.933l.97 5.823h10.267l3.32-11.344A.573.573 0 0 1 27.56 13h2.868a.574.574 0 0 1 0 1.147h-2.438l-3.32 11.344Z"
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "translate(-.667 2.222)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "b",
					fill: "#fff",
					children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
				}),
				/* @__PURE__ */ _jsx("use", {
					xlinkHref: "#a",
					fill: "#000",
					fillRule: "nonzero"
				}),
				/* @__PURE__ */ _jsx("g", {
					fill: "#000",
					mask: "url(#b)",
					children: /* @__PURE__ */ _jsx("path", { d: "M0 0h18.667v18.667H0z" })
				})
			]
		})]
	})]
});
export default SvgReorder;
